import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

import { getPendingChoice, subscribeChoice, type ChoiceRequest } from '@/auth/roleSelection';
import { RoleSelectionList } from './RoleSelectionList';

/**
 * The role selection screen (Authorization-Plan §6.2: several valid
 * assignments and none active). Opened by requestRoleChoice() at sign-in or at
 * page load; it cannot be dismissed: the flow waits for a choice.
 */
export const RoleSelectionHost = () => {
  const [request, setRequest] = useState<ChoiceRequest | null>(getPendingChoice());
  const [busy, setBusy] = useState(false);

  useEffect(
    () =>
      subscribeChoice((next) => {
        setRequest(next);
        setBusy(false);
      }),
    [],
  );

  if (!request) return null;

  return (
    <Dialog
      open
      fullWidth
      maxWidth='sm'
      aria-labelledby='role-selection-title'
      sx={{ zIndex: 2000 }}
    >
      <DialogTitle id='role-selection-title'>Choose your role</DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ mb: 2 }}>
          You have more than one role. Choose the one to work with; you can switch later from the
          header.
        </Typography>
        <RoleSelectionList
          assignments={request.assignments}
          disabled={busy}
          onSelect={(assignment) => {
            setBusy(true);
            request.resolve(assignment);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default RoleSelectionHost;
